import React from 'react';
import { getOptions } from '../aggregationUtil';
import { newInteractiveFilter } from './interactiveFilter';

const Filter = newInteractiveFilter('company_id', getOptions);

export const CompanyInteractiveFilter = ({
  companies,
  aggregationQuery,
  onSelectValue,
  onClearValue,
  label,
  ...additionalProps
}) => (
  <Filter
    options={companies}
    aggregationQuery={aggregationQuery}
    onSelectValue={onSelectValue}
    onClearValue={onClearValue}
    label={label}
    {...additionalProps}
  />
);
